

























































import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
// import { Helper } from "../Mtc_classes";
// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

@Component({
  components: {}
})
export default class DatePicker extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
	// mounted(){}
	// created(){}

	/* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop()
  public label: string;

  @Prop()
  public value: Date;

  @Prop({type: Boolean, default:false})
  public readonly: boolean;

  @Prop({type: Boolean, default:false})
  public clearable: boolean;

  @Prop({type: Boolean, default:false})
  public landscape: boolean;

	/* PRIVATE VARIABLES, __ POSTFIXED */
  // private myVar__: any;

  /* VUE DATA */
	public date: Date = null;
	public menu: boolean = false;

  /* VUE WATCH */
  @Watch("date")
  onDateChanged(newVal: any, oldVal: any) {
		this.$emit('input', newVal);

		if (newVal!= oldVal){
				this.$emit("change", newVal);
		}
	}

  @Watch("value", {immediate:true})
  onValueChanged(newVal: any, oldVal: any) {

		// if (newVal)
		// 	newVal = Helper.MomentFormatDate(newVal);

		this.date = newVal;
	}


  /* VUE COMPUTED METHODS */
  get CanClear() : boolean {
		var canClear :boolean= this.clearable && this.date!=undefined ;
		return canClear;
  }

  /* PRIVATE METHODS */
  // private MyFunction():void{}

  /* VUE METHODS */
   public ClearDate():void{
		 this.date = null;
		 this.menu = false;
	 }
}
